import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../verifyemail/auth.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-verifyemail',
  templateUrl: './verifyemail.component.html',
  styleUrls: ['./verifyemail.component.css']
})
export class VerifyemailComponent implements OnInit {

  public registerForm:FormGroup; 
  validmsg: any;
  registerbtn: any;
  generated_OTP: any;

  time: number = 31;
  display : any;
  interval: any;

  resstatus = localStorage.getItem('resstatus');
  mobileverification = localStorage.getItem('mobileverification');  

  constructor(
    private fb: FormBuilder, 
    private authService: AuthService,
    private route: Router
    ) { 
      this.route.events.subscribe((e) => {
        if (this.resstatus == null) {
            this.route.navigate(['/home']);
        }        
        if (this.resstatus == null && this.mobileverification == null) {
          this.route.navigate(['/register']);
        }
        if (this.mobileverification == null) {
          this.route.navigate(['/verify-mobile']);
        }    
      });
  }

  ngOnInit(): void {

    this.initialize();    

  }

  initialize(){

    this.validmsg = '';
    $('#validmsg').css('display', 'none');

    if (navigator.userAgent.indexOf("Firefox") > 0) {
      $(".div-center").attr('style', 'top: -250px');
    }

    // Form element defined below
    this.registerForm = this.fb.group({
      username: new FormControl('', Validators.required),
      otp: new FormControl('')
    });    

  } 

  isNumber(evt: any) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
  
  generate_OTP() {
      
    $('#validmsg').css('display', 'none');

    let postdataObj = {
      "tokenable_id":localStorage.getItem('tokenable_id'),
      "email_address": this.registerForm.controls.username.value
    };

    this.authService.generate_OTP(postdataObj)
    .subscribe((result: any) => {
      if (result.status == true) {                        

        this.generated_OTP = result.data;
        this.validmsg = result.message;
        $('#validmsg').css('display', 'block');
        $('#verifyOTP').css('display', 'block');

        // Resend OTP
        this.startTimer();

      } else {
        // console.log(result);            
      }
    }, (error) => {
      this.validmsg = error.error.message;
      $('#validmsg').css('display', 'block');          
    });

  }  

  verify_OTP() {
    
    $('#validmsg').css('display', 'none');
    
    let postdataObj = {
      "tokenable_id":localStorage.getItem('tokenable_id'),
      "email_address": this.registerForm.controls.username.value,
      "email_otp": this.registerForm.controls.otp.value
    };

    this.authService.verify_OTP(postdataObj)
    .subscribe((result: any) => {
      console.log(result);
      if (result.status == true) {                        

        localStorage.setItem('pagehide', 'no');
        this.route.navigate(['/clientCreation']);

      } else {
        // console.log(result);  
          this.validmsg = result.message;
          $('#validmsg').css('display', 'block');          
      }
    }, (error) => {
      this.validmsg = error.error.message;
      $('#validmsg').css('display', 'block');          
    });     
    
  }

  goback(){
    localStorage.clear();
    this.route.navigate(['/register']);
  }
  
  /********** Resend OTP Timer *****/
  startTimer() {
    $('#resendbtn').css('display','block');
    this.interval = setInterval(() => {
      if (this.time === 31) {
        this.time--;
      } else {
        this.time--;
      }
      this.display=this.transform( this.time);
      if(this.time == 0){
        this.pauseTimer();
      }
    }, 1000);
  }
  transform(value: number): string {
       const minutes: number = Math.floor(value / 60);
       return minutes + ':' + (value - minutes * 60);
  }
  pauseTimer() {
    clearInterval(this.interval);
    $('#timer').css('display','none');
    $('#resendlink').prop('disabled', false);
    $('#resendlink').css('color', '#4E0099');
    $('#resendlink').css('cursor', 'pointer');    
  }
  resendotp(){
    this.generate_OTP();
    this.validmsg = 'Resending OTP..';
    $('#validmsg').css('display', 'block');
  }
  /********************************/

}
